import { connect } from 'react-redux';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { errorBoundary, sendTelemetryErrorEvent } from '../../common/react/components/ErrorBoundary';
import { selectShowWelcomeChannelForUserFromAppState } from '../selectors/HomeSelectors';
import { HomeUserUtils } from '../utils/HomeUserUtils';
import { Home, HomeDispatchProps, HomeStateProps } from './Home';

const mapStateToProps: MapStateToProps<HomeStateProps> = (state: AppState) => ({
  userSiteRole: HomeUserUtils.getRole(state),
  showWelcomeChannel: selectShowWelcomeChannelForUserFromAppState(state),
  favoritesCount: state.home.favorites.items.length,
  recentsCount: state.home.recents.items.length,
  popularCount: state.home.popular.items.length,
  recommendationsCount: state.home.recommendations.items.length,
  sharedWithMeCount: state.home.sharedWithMe.items.length,
  isFetchingFavorites: state.home.favorites.isFetching,
  isFetchingRecents: state.home.recents.isFetching,
  isFetchingRecommendations: state.home.recommendations.isFetching,
  isNamedSharingEnabled: SessionSiteSelectors.isNamedSharingEnabled(state),
  recommendationsEnabled: SessionSiteSelectors.isVizRecommendationsEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<HomeDispatchProps> = (dispatch) => ({
  enterHome: () => {
    // Request ContentInfoCardChannel content
    dispatch(requestSpaceContents());
  }
});

const InternalConnectedHome = connect(mapStateToProps, mapDispatchToProps)(Home);
export const ConnectedHome = errorBoundary(sendTelemetryErrorEvent)(InternalConnectedHome);
